export default {
  public: {
    loading: "Loading...",
    ok: "OK",
    cancel: "Cancel",
    back: "Back",
    userDefined: "Custom",
    edit: "Edit",
    clear: "Clear",
    delete: "Delete",
    close: "Close",
    remove: "Remove",
    preView: "Preview",
    replace: "Replace",
    systemMsg: "Information",
    generateSuccess:
      "Your PowerPoint presentation has been successfully generated!",
    templateChoose: "Choose a template to complete your own AI creation",
    templateChooseShort: "Choose a template",
    templateChangeTips:
      "Replacing template data will restore it to its original content. Modified content will be lost. Are you sure you want to continue?",
    sourceInvalid: "The data source is invalid, please try again.",
    systemBusy: "Sever is busy,please refresh the page.",
    templateReplaceSuccess:
      "The template replacement was successful. Please save manually, as the system will not save automatically.",
    shareLinkTips: "Copy success Redirecting web page now!",
    noPermissionTips:
      "Sorry, the sharing permission of this ppt has been closed by the author~ You can log in to aippttv, show your imagination, and create your own ppt!",
    copyTips: "Copy success!",
    loginTips: "Please log in first!",
    bottomTag: "Made with {brand}",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "Font",
      sysFont: "System Font",
      lineFont: "Online Font",
      fontColor: "Text Color",
      textColor: "Font Color",
      fontDelay: "Font Highlight",
      addSize: "Increase Font Size",
      duceSize: "Decrease Font Size",
      left: "Left Align",
      middle: "Center",
      horizontalCenter: "Horizontal Center",
      verticalCenter: "Vertical Center",
      right: "Right Align",
      bottom: "Bottom Align",
      top: "Top Align",
      bold: "Bold",
      em: "Italic",
      underline: "Underline",
      strikethrough: "Strikethrough",
      richText: "Clear Formatting",
      textFormat: "Format Brush",
      addIndex: "Increase Indent",
      duceIndex: "Decrease Indent",
      no: "Numbering",
      link: "Hyperlink",
      inputLink: "Enter Hyperlink",
      superscript: "Superscript",
      subscript: "Subscript",
      code: "Inline Code",
      blockquote: "Quote",
      horizontal: "Horizontal",
      vertical: "Vertical",
      width: "Width",
      height: "Height",
      rotate: "Rotate",
      uniformHorizontal: "Distribute Horizontally",
      uniformVertical: "Distribute Vertically",
      combine: "Combine",
      unCombine: "Ungroup",
      bgColor: "Background Color",
      mainColor: "Theme Color",
      useMainToAll: "Apply Theme to All",
      preMain: "Predefined Theme",
    },
    specialEffects: {
      useAll: "Apply to All",
      no: "None",
      fade: "Fade In/Out",
      slideX: "Slide Left/Right",
      slideY: "Slide Up/Down",
    },
  },
  chart: {
    insertCol: "Insert Column",
    insertRow: "Insert Row",
    delCol: "Delete Column",
    delRow: "Delete Row",
    merCell: "Merge cells",
    unMerCell: "Unmerge cells",
    selectCurrentCol: "Select current column",
    selectCurrentRow: "Select current Row",
    selectAll: "Select all cells",
    toTheLeft: "To the left",
    toTheRight: "To the right",
    toTheTop: "To the top",
    toTheBottom: "To the bottom",
  },
  desktop: {
    fileExportSuccess:
      "The file is successfully exported. Select a location to save the file",
    unSupportPreviewPDF:
      "PDF preview is not available here. If you want to preview, please go to the PC official website.",
  },
  extension: {
    nonsupportDownloadPDF:
      "Browser plug-in does not support downloading PDF, please go to the official website to download",
  },
  index: {
    createText: "Generating PPT Content",
    createPage: "Generating Content for Page {0}",
    haveProblem: "I have a problem",
    systemError: "{0}",
    saveText: "Successfully saved",
    saveMessage: "Are you sure to save?",
    cBtn: "Cancel",
    sBtn: "OK",
    waitMsg:
      "Please be patient and wait for 30-40 seconds. If it does not generate, please refresh your browser and try again!",
  },
  errorCode: {
    "401": "Authentication failed, unable to access system resources",
    "403": "Current operation is not permitted",
    "404": "Resource not found",
    default: "Unknown system error, please report to the administrator",
    notReDo: "Data is being processed, please do not resubmit.",
    loginMsg: "Invalid session or session has expired. Please log in again.",
    errMsg: "System is busy, please try again later.",
  },
  linkHandler: {
    pptPage: "Slide Page",
    change: "Change",
    remove: "Remove",
  },
  editor: {
    ctrlV: "Paste",
    ctrlA: "Select All",
    enter: "New Page",
    f5: "Slide Show",
    delete: "Delete Page",
    ctrlD: "Duplicate Page",
    ctrlX: "Cut",
    ctrlC: "Copy",
    shiftF5: "Start from Current",
    positionPanel: {
      horizontalCenter: "Center horizontally",
      verticalCenter: "Center vertically",
      horizontalVerticalCenter: "Center horizontally and vertically",
      left: "Align left",
      right: "Align right",
      top: "Align top",
      bottom: "Align bottom",
      onTop: "Put on Top",
      onBottom: "put on bottom",
      levelUp: "Move one level up",
      levelDown: "Move down one level",
      setLink: "Set Link",
      ungroup: "Ungroup",
      group: "Group",
      selectAll: "Select All",
      lock: "Locking",
      unlock: "unlock",
      delete: "Delete",
    },
    canvas: {
      index: {
        ctrlR: "Ruler",
        ctrlW: "Gridlines",
        nl: "None",
        small: "Small",
        middle: "Medium",
        big: "Large",
        closePan: "Close Selection Panel",
        openPan: "Open Selection Panel",
        reCurrentPage: "Reset Current Page",
        showPpt: "Slide Show",
        generate: "Generating...",
      },
      linkDialog: {
        url: "Please Enter the Web Link Address",
        ppt: "Slide",
        preView: "Preview",
        pageUrl: "Web Link",
        pptPage: "Slide Page",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "Undo",
        reSet: "Redo",
        text: "Insert Text",
        horizontal: "Horizontal Text Box",
        vertical: "Vertical Text Box",
        image: "Insert Image",
        shape: "Insert Shape",
        line: "Insert Line",
        chart: "Insert Chart",
        table: "Insert Table",
        gs: "Insert Formula",
        voice: "Insert Audio/Video",
        screen: "Fit to Screen",
        workspase: "Workspace",
        save: "Save",
        logo: "Insert Logo",
        close: "Close PPT",
        share: "Share",
        download: "Download",
        templateReplacement: "Template replacement",
      },
      mediaInput: {
        videoUrl: "Enter Video URL, e.g., https://xxx.mp4",
        voiceUrl: "Enter Audio URL, e.g., https://xxx.mp3",
        video: "Video",
        voice: "Audio",
        videoError: "Please Enter a Correct Video URL First",
        voiceError: "Please Enter a Correct Audio URL First",
      },
      tableGenerator: {
        table: "Table",
        row: "Rows",
        column: "Columns",
        rcError: "Rows/Columns must be between 0 and 20!",
      },
      logo: {
        text1: "Upload company Logo",
        text2: "Enter the company name",
        companyNamePlaceholder: "enter you company name",
        single: "Single page apply",
        all: "All page apply",
        position: "position",
      },
    },
    editorHeader: {
      index: {
        file: "File",
        importPptistFile: "Import pptist File",
        importPptxFile: "Import pptx File",
        exportPptxFile: "Export File",
        undo: "Undo",
        redo: "Redo",
        createSlide: "Add Page",
        deleteSlide: "Delete Page",
        closeGridLines: "Close Gridlines",
        openGridLines: "Open Gridlines",
        closeRuler: "Close Ruler",
        openRuler: "Open Ruler",
        resetSlides: "Reset Slides",
        closeSelectPanel: "Close Selection Panel",
        openSelectPanel: "Open Selection Panel",
        f5: "Present",
        enterScreeningFromStart: "Start from Beginning",
        enterScreening: "Start from Current Page",
        help: "Help",
        hotkey: "Hotkeys",
        pptShow: "Slide Show",
        export: "Export",
        importing: "Importing...",
        continue: "Continue",
        pauseGeneration: "Pause",
        noPricing: "Become a member and enjoy download privileges with us.",
        noPricingToOpt: "Unlock all privileges.",
        getTokens: "Upgrade To Pro",
        pptSlidesMsg: "Congratulations on creating {0} complete PPT slides! ",
        Feedback: "Let AI be your work assistant.",
        giveAway: "Give away coupons(valid for 30 minutes)",
        getItNow: "Get it now",
        unlockAllPpt: "Unlock all PPT features",
        grantPermission: "Grant permission to use AI mind map",
        grantPermissionToUseGpt: "Grant permission to use GPT",
        permissionCodeUse:
          "Please remember the discount code and proceed to the payment webpage for use!",
        pptTi1:
          "You have completed all the work and generated a total of {0} pages of ppt. ",
        pptTi2:
          "You only need the last step to get your wonderful AI creation!",
      },
    },
    exportDialog: {
      tips: "PPT download is not supported in the app at this time;Please DownLoad on the PC",
      exportScope: "Export Scope",
      close: "Close",
      all: "All",
      thisPage: "Current",
      auto: "Custom",
      autoScope: "Custom Range",
      exporting: "Exporting...",
      exportImg: "Export Image",
      expPdf: "Print / Export PDF",
      expPptx: "Export PPTX",
      downloadSuccess: "File conversion successful. Please select a save path",
      exportImage: {
        exportType: "Export Format",
        imageQuality: "Image Quality",
        ignoreFont: "Ignore Online Fonts",
        ignoreLineFont:
          "By default, online fonts will be ignored during export. If you have used online fonts in the presentation and want to retain their styles after export, you can choose to turn off the 'Ignore Online Fonts' option, but please note that this may increase the export time.",
      },
      exportPdf: {
        all: "All Slides",
        thisPage: "Current Slide",
        pageNum: "Pages per Sheet",
        white: "Margin",
        notice:
          "Note: If the print preview does not match the actual style, please check the 'Background Graphics' option in the pop-up print window.",
      },
      exportPPTX: {
        title: "Override Default Master",
        notice:
          "Note: After downloading, please open it with Microsoft Office, as others may not be compatible.",
      },
    },
    remark: {
      remark: "Click to Enter Speaker Notes",
    },
    thumbnails: {
      add: "Add Slide",
      slide: "Slide",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "Recolor (Mask)",
          maskColor: "Mask Color",
          opacity: "Opacity",
        },
        elementFilter: {
          enableFilter: "Enable Filters",
          blur: "Blur",
          brightness: "Brightness",
          contrast: "Contrast",
          grayscale: "Grayscale",
          saturate: "Saturate",
          hueRotate: "Hue Rotate",
          opacity: "Opacity",
        },
        elementFlip: {
          horizontal: "Flip Horizontally",
          vertical: "Flip Vertically",
        },
        elementOpacity: {
          opacity: "Opacity",
        },
        elementOutline: {
          border: "Enable Border",
          borderStyle: "Border Style",
          solid: "Solid Border",
          dashes: "Dashed Border",
          borderColor: "Border Color",
          borderWeight: "Border Weight",
        },
        elementShadow: {
          enable: "Enable Shadow",
          horizontal: "Horizontal Shadow",
          vertical: "Vertical Shadow",
          fuzzyDistance: "Blur Distance",
          color: "Shadow Color",
        },
      },
      panel: {
        background: "Background Fill",
        solid: "Solid Color Fill",
        image: "Image Fill",
        gradient: "Gradient Fill",
        contain: "Fit",
        repeat: "Tile",
        cover: "Fit to Fill",
        linear: "Linear Gradient",
        radial: "Radial Gradient",
        startColor: "Start Color",
        endColor: "End Color",
        rotate: "Gradient Angle",
        useBackgroundToAll: "Apply Background to All",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "Category",
            colType: "Series",
          },
          index: {
            edit: "Edit Chart Data",
            area: "Area Chart Style",
            line: "Scatter Chart Style",
            lineSmooth: "Use Smooth Line",
            horizontalBars: "Bar Chart Style",
            stackBars: "Stacked Style",
            donut: "Donut Chart Style",
            img: "Legend",
            hidden: "Hide",
            showTop: "Show at Top",
            showBottom: "Show at Bottom",
            tabColor: "Grid Color",
            labelColor: "Font Color",
            titleSetColor: "Theme Colors:",
            title: "Recommended Themes",
            titleColor: "Add Theme Color",
          },
        },
        audioStylePanel: {
          imgColor: "Icon Color",
          autoPlay: "Auto Play",
          loopPlay: "Loop Play",
        },
        imageStylePanel: {
          cutImg: "Crop Image",
          shape: "By Shape",
          type: "Category",
          preview: "Preview",
          use: "Use",
          searchByType: "Search by Category",
          uploadAndReplace: "Upload and Replace Image",
          reSetStyle: "Reset Style",
          setBackground: "Set as Background",
          clip1: "By Aspect Ratio (Square)",
          clip2: "By Aspect Ratio (Portrait)",
          clip3: "By Aspect Ratio (Landscape)",
        },
        latexStylePanel: {
          edit: "Edit LaTeX",
          color: "Color",
          bold: "Bold",
        },
        lineStylePanel: {
          style: "Line Style",
          solid: "Solid Line",
          dotted: "Dotted Line",
          color: "Line Color",
          weight: "Line Width",
          startStyle: "Start Style",
          endStyle: "End Style",
          none: "None",
          arrow: "Arrow",
          dot: "Dot",
        },
        multiStylePanel: {
          colorPicker: "Fill Color",
          style: "Border Style",
          solid: "Solid Border",
          dotted: "Dotted Border",
          color: "Border Color",
          weight: "Border Width",
        },
        shapeStylePanel: {
          replaceShade: "Click to Replace Shape",
          fill: "Solid Fill",
          gradient: "Gradient Fill",
          linear: "Linear Gradient",
          radial: "Radial Gradient",
        },
        tableStylePanel: {
          colFull: "Cell Fill",
          row: "Rows",
          col: "Columns",
          titleRow: "Title Row",
          totalRow: "Total Row",
          firstCol: "First Column",
          lastCol: "Last Column",
          titleColor: "Theme Color",
          themeTable: "Theme Table",
        },
        textStylePanel: {
          urlError: "Not a Correct Web Link Address",
          command: "Bulleted List",
          lineHeight: "Line Spacing",
          times: "Times",
          paragraphSpace: "Paragraph Spacing",
          wordSpace: "Word Spacing",
          textIndent: "First Line Indent",
          textFill: "Text Box Fill",
          title: "Title",
          titleSmall: "Subtitle",
          text: "Text",
          textSmall: "Text [Small]",
          zs1: "Note 1",
          zs2: "Note 2",
        },
        videoStylePanel: {
          cover: "Video Preview Cover",
          recover: "Reset Cover",
        },
      },
      elementAnimationPanel: {
        addEffects: "Add Animation",
        selectAndAddEffects: "Select Elements on Canvas and Add Animation",
        time: "Duration",
        triggerType: "Trigger Type",
        initiative: "Initiative Trigger",
        sameTime: "Simultaneously with Previous",
        after: "After Previous",
        change: "Change Animation",
        in: "Entrance",
        out: "Exit",
        attention: "Emphasis",
      },
      elementPositionPanel: {
        layer: "Layer",
        align: "Align",
        top: "Bring to Front",
        bottom: "Send to Back",
        up: "Bring Forward",
        down: "Send Backward",
        noRixedRatio: "Unlock Aspect Ratio",
        fixedRatio: "Lock Aspect Ratio",
      },
      index: {
        style: "Style",
        symbol: "Symbol",
        position: "Position",
        animation: "Animation",
        design: "Design",
        slideAnimation: "Transitions",
      },
      slideDesignPanel: {
        canvasSize: "Canvas Size",
        wideScreen1: "Widescreen 16:9",
        wideScreen2: "Widescreen 16:10",
        standard: "Standard 4:3",
        paper: "A3 / A4 Paper",
        title: "Global Theme",
        mainColor: "Theme Color",
        useMainToAll: "Apply Theme to All",
        preMain: "Predefined Theme",
        text: "Text Aa",
        use: "Apply",
        useToAll: "Apply All",
      },
    },
    selectPanel: {
      select: "Select",
      showAll: "Show All",
      hideAll: "Hide All",
      group: "Group",
    },
    redraw: {
      topLabel: "Redraw",
      msgTips: "Please enter the generated content",
      retext: "Redraw",
      cltext: "Cancel",
      btnText: "Create",
      reConfirm:
        "Generating this will replace the current page and will not save the historical content. Are you sure you want to continue?",
      confirmBtnTxt: "Continue",
    },
  },
  screen: {
    presenter: {
      normalView: "Normal View",
      pen: "Pen",
      laserPointer: "Laser Pointer",
      timer: "Timer",
      exitFullScreen: "Exit Full Screen",
      fullScreen: "Full Screen",
      endPresentation: "End Presentation",
      speakerNotes: "Speaker Notes",
      speakersView: "Speaker's View",
      previousPage: "Previous Page",
      nextPage: "Next Page",
      firstPage: "First Page",
      lastPage: "Last Page",
      brushTool: "Brush Tool",
      noRemarks: "No remarks",
      lastPageTips: "Already the last page",
      firstPageTips: "Already the first page",
      autoPlay: "Start automatic show",
    },
    writingBoard: {
      inkThickness: "Ink thickness",
      eraserSize: "Eraser size",
      eraser: "Eraser",
      clearInk: "Clear ink",
      blackboard: "Blackboard",
      closeBrush: "Close brush",
    },
  },
  mobile: {
    index: {
      notSupport: "The mobile version is being developed urgently.",
      toPc: "Please visit the website on a PC.",
      editTips: "Please edit on the PC.",
    },
  },
  useCreateElement: {
    type: "Type{0}",
    class: "Series{0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "Enter LaTeX Formula",
        preViw: "Formula Preview",
        symbol: "Common Symbols",
        formula: "Predefined Formulas",
        error: "Formula cannot be empty",
      },
    },
    colorPicker: {
      recentUse: "Recent use",
    },
  },
  config: {
    latex: {
      gauss: "Gaussian Formula",
      fourierSeries: "Fourier Series",
      taylorExpansion: "Taylor Expansion",
      definiteIntegral: "Definite Integral",
      trigonometricIdentity1: "Trigonometric Identity 1",
      trigonometricIdentity2: "Trigonometric Identity 2",
      expansion: "Sum Expansion",
      euler: "Euler's Formula",
      differential: "Bernoulli Equation",
      totalDifferentialEquation: "Total Differential Equation",
      homogeneous: "Nonhomogeneous Equation",
      cauchy: "Cauchy Mean Value Theorem",
      lagrange: "Lagrange Mean Value Theorem",
      arcsin: "Derivative Formula",
      trigonometric: "Trigonometric Function Integration",
      quadric: "Quadratic Surface",
      dx: "Second-order Differential",
      partial: "Directional Derivative",
      operators: "Mathematics",
      group: "Combinations",
      verbatim: "Functions",
      greek: "Greek Letters",
    },
    symbol: {
      letter: "letter",
      number: "number",
      math: "math",
      arrow: "arrow",
      graph: "graph",
    },
    lines: {
      straight: "Straight",
      brokenOrCurve: "Broken or Curve",
    },
  },
  hotkey: {
    opt: {
      common: "Common",
      ctrlX: "Cut",
      ctrlC: "Copy",
      ctrlV: "Paste",
      ctrlD: "Fast Copy Paste",
      ctrlA: "Select All",
      ctrlZ: "Undo",
      ctrlY: "Redo",
      del: "Delete",
      ctrlMore: "Multi-select",
      ctrlP: "Print",
      esc: "Close Popup",
    },
    slide: {
      show: "Slide Show",
      edit: "Slide Edit",
      first: "Start Slide Show from Beginning",
      current: "Start Slide Show from Current",
      spacePre: "Switch to Previous Page",
      spaceNext1: "Switch to Next Page",
      spaceNext2: "Switch to Next Page",
      out: "Exit Presentation",
      new: "New Slide",
      move: "Move Canvas",
      upOrDown: "Zoom Canvas",
      up: "Zoom In Canvas",
      down: "Zoom Out Canvas",
      screen: "Fit Canvas to Current Screen",
      noSelectPrePage: "Previous Page (Unselected Elements)",
      noSelectNextPage: "Next Page (Unselected Elements)",
      prePage: "Previous Page",
      nextPage: "Next Page",
    },
    element: {
      opt: "Element Operations",
      move: "Move",
      lock: "Lock",
      combo: "Group",
      cancelCombo: "Ungroup",
      top: "Bring to Front",
      bottom: "Send to Back",
      h: "Lock Aspect Ratio",
      v: "Create Horizontal / Vertical Line",
      change: "Switch Focus Element",
      com: "Confirm Image Cropping",
      text: "text",
      image: "image",
      shape: "shape",
      line: "line",
      chart: "chart",
      table: "table",
      video: "video",
      audio: "audio",
      latex: "Formula",
    },
    table: {
      edit: "Table Edit",
      nextCol: "Focus on Next Cell",
      insertTop: "Insert Row Above",
      insertBottom: "Insert Row Below",
      insertLeft: "Insert Column on the Left",
      insertRight: "Insert Column on the Right",
    },
    chat: {
      edit: "Chart Data Edit",
      nextLine: "Focus on Next Line",
    },
    text: {
      edit: "Text Edit",
      bold: "Bold",
      italics: "Italic",
      underline: "Underline",
      delLine: "Strikethrough",
    },
  },
  shape: {
    rectangle: "Rectangle",
    commonUse: "Common Shapes",
    arrow: "Arrow",
    other: "Other Shapes",
    line: "Line",
  },
  animation: {
    in: {
      bounce: "bounce",
      bounceIn: "bounceIn",
      bounceInLeft: "bounceInLeft",
      bounceInRight: "bounceInRight",
      bounceInUp: "bounceInUp",
      bounceInDown: "bounceInDown",
      fade: "fade",
      fadeIn: "fadeIn",
      fadeInDown: "fadeInDown",
      fadeInDownBig: "fadeInDownBig",
      fadeInLeft: "fadeInLeft",
      fadeInLeftBig: "fadeInLeftBig",
      fadeInRight: "fadeInRight",
      fadeInRightBig: "fadeInRightBig",
      fadeInUp: "fadeInUp",
      fadeInUpBig: "fadeInUpBig",
      fadeInTopLeft: "fadeInTopLeft",
      fadeInTopRight: "fadeInTopRight",
      fadeInBottomLeft: "fadeInBottomLeft",
      fadeInBottomRight: "fadeInBottomRight",
      rotate: "rotate",
      rotateIn: "rotateIn",
      rotateInDownLeft: "rotateInDownLeft",
      rotateInDownRight: "rotateInDownRight",
      rotateInUpLeft: "rotateInUpLeft",
      rotateInUpRight: "rotateInUpRight",
      zoom: "zoom",
      zoomIn: "zoomIn",
      zoomInDown: "zoomInDown",
      zoomInLeft: "zoomInLeft",
      zoomInRight: "zoomInRight",
      zoomInUp: "zoomInUp",
      slide: "slide",
      slideInDown: "slideInDown",
      slideInLeft: "slideInLeft",
      slideInRight: "slideInRight",
      slideInUp: "slideInUp",
      flip: "flip",
      flipInX: "flipInX",
      flipInY: "flipInY",
      back: "back",
      backInDown: "backInDown",
      backInLeft: "backInLeft",
      backInRight: "backInRight",
      backInUp: "backInUp",
      lightSpeed: "lightSpeed",
      lightSpeedInRight: "lightSpeedInRight",
      lightSpeedInLeft: "lightSpeedInLeft",
    },
    out: {
      bounce: "bounce",
      bounceOut: "bounceOut",
      bounceOutLeft: "bounceOutLeft",
      bounceOutRight: "bounceOutRight",
      bounceOutUp: "bounceOutUp",
      bounceOutDown: "bounceOutDown",
      fade: "fade",
      fadeOut: "fadeOut",
      fadeOutDown: "fadeOutDown",
      fadeOutDownBig: "fadeOutDownBig",
      fadeOutLeft: "fadeOutLeft",
      fadeOutLeftBig: "fadeOutLeftBig",
      fadeOutRight: "fadeOutRight",
      fadeOutRightBig: "fadeOutRightBig",
      fadeOutUp: "fadeOutUp",
      fadeOutUpBig: "fadeOutUpBig",
      fadeOutTopLeft: "fadeOutTopLeft",
      fadeOutTopRight: "fadeOutTopRight",
      fadeOutBottomLeft: "fadeOutBottomLeft",
      fadeOutBottomRight: "fadeOutBottomRight",
      rotate: "rotate",
      rotateOut: "rotateOut",
      rotateOutDownLeft: "rotateOutDownLeft",
      rotateOutDownRight: "rotateOutDownRight",
      rotateOutUpLeft: "rotateOutUpLeft",
      rotateOutUpRight: "rotateOutUpRight",
      zoom: "zoom",
      zoomOut: "zoomOut",
      zoomOutDown: "zoomOutDown",
      zoomOutLeft: "zoomOutLeft",
      zoomOutRight: "zoomOutRight",
      zoomOutUp: "zoomOutUp",
      slide: "slide",
      slideOutDown: "slideOutDown",
      slideOutLeft: "slideOutLeft",
      slideOutRight: "slideOutRight",
      slideOutUp: "slideOutUp",
      flip: "flip",
      flipOutX: "flipOutX",
      flipOutY: "flipOutY",
      back: "back",
      backOutDown: "backOutDown",
      backOutLeft: "backOutLeft",
      backOutRight: "backOutRight",
      backOutUp: "backOutUp",
      lightSpeed: "lightSpeed",
      lightSpeedOutRight: "lightSpeedOutRight",
      lightSpeedOutLeft: "lightSpeedOutLeft",
    },
    attention: {
      shake: "shake",
      shakeX: "shakeX",
      shakeY: "shakeY",
      headShake: "headShake",
      swing: "swing",
      wobble: "wobble",
      tada: "tada",
      jello: "jello",
      other: "other",
      bounce: "bounce",
      flash: "flash",
      pulse: "pulse",
      rubberBand: "rubberBand",
      heartBeat: "heartBeat",
    },
  },
  requestError: {
    tokenExpires: "Authentication failed, unable to access system resources",
    permissionDenied: "Current operation is not permitted",
    notFound: "Resource not found",
    default: "Unknown system error, please report to the administrator",
    exceptionReminder: "Exception reminder",
    pleaseLogin:
      "Invalid session, or the session has expired, please log in again.",
    networkError: "Network Error",
    requestTimeOut: "System interface request timeout",
    requestFailed: "Request failed",
  },
  promptsText: {
    theme: [
      "Explore different themes and discover endless fun!",
      "Click into each theme page and embark on a magical journey!",
      "Each theme has its own unique charm, why not explore them all?",
      "Welcome to the world of themes, choose your interests and start your adventure!",
      "Your first AI slideshow is about to arrive, stay tuned!",
      "Embark on a slideshow journey, departure imminent...",
      "Ready for a new visual feast? The slideshow is about to commence...",
      "Hold on tight! Next stop, the fantastic slideshow journey...",
      "Quick! Close your eyes and wait for the surprise slideshow to arrive...",
      "The slideshow world is about to unfold before you, stay tuned...",
      "Please be patient, the dream of the slideshow is about to come true...",
    ],
    directory: [
      "Find everything you need on the directory page!",
      "The directory page is your navigation treasure, making it easy for you to find what you need!",
      "The directory page provides comprehensive navigation services, allowing you to quickly find your targets!",
      "Not sure where to go? Find inspiration and direction on the directory page!",
    ],
    Content: [
      "Awaiting... the next slide will be as colorful as a rainbow!",
      "Wow! The next slide will blossom like fireworks, leaving you amazed!",
      "Be patient, the next slide will be as wonderful as waiting for a dreamy rainbow to appear!",
      "Feel the magic of waiting! The next slide will brighten your eyes!",
      "Stay tuned! The next slide will bring you a surprise visual feast!",
      "Quick! Pull up the curtains, get ready to embrace the dazzling light of the next slide!",
      "Get ready! The next slide will bring a fresh visual storm!",
      "Your curiosity is about to be satisfied! The next slide will surprise you!",
      "Awaiting... the next slide will take you on a wonderful visual journey!",
      "Can't wait? The next slide will be as exciting as a grand celebration!",
      "Guess what the next slide will be? The answer is about to be revealed...",
      "Please fasten your seatbelt, we are about to fly to the next slide...",
      "Happiness is coming! The next slide is speeding towards you...",
      "Guess what color the next slide will be? The answer is about to be revealed...",
      "Wow! The next slide will bring you unexpected surprises...",
      "Eager to try? The next slide will satisfy your curiosity...",
      "Awaiting... the next slide will bring you joy and surprises...",
      "Awaiting... just like waiting for a delicious cup of coffee, the next slide will delight your mood!",
      "Close your eyes, count to three, the next slide will bring surprises! 1... 2... 3...",
      "In adventure! Waiting for the next slide is as exciting as discovering treasure!",
      "Are you ready? The next slide will take you on a wonderful adventure!",
    ],
    Comprehensive: [
      "Bit by bit, explore the endless world of fun!",
      "From themes to directories, and then to content pages, every step is a journey of discovery!",
      "Let's embark on a wonderful journey together, leaving our marks in this exciting world!",
      "On this surprising website, let's discover more together!",
    ],
    Unpurchased: [
      "Eager to try? The next slide will kick off a visual feast, come join us!",
      "More than just products, it's a way of life! Click to purchase and let your mood fly!",
      "Here, you're not just buying products, but also buying happiness in abundance!",
      "Join as a member and start a new chapter of joyful life!",
      "Click to purchase and make every day full of surprises and fun!",
      "Purchasing is more than an action, it's a way to enjoy life!",
      "Seize the opportunity, purchase your desired products, and make life more colorful!",
      "Purchasing is a wonderful adventure, let's embark on this journey together!",
      "Click to purchase, bring yourself a surprise and happiness!",
      "Purchasing is an expression, let's choose with heart together!",
    ],
  },
};
